<form
  id="shared-textarea-form"
  [ngClass]="customTextAreaClass"
  class="textarea-form"
  [ngStyle]="getFormStyles()"
>
  <mat-form-field
    id="shared-textarea-form-field"
    class="textarea-form-field"
    [ngClass]="{
      'custom-invalid-error': hasCustomError
    }"
    appearance="fill"
  >
    <textarea
      id="shared-textarea-input-field"
      class="textarea-input"
      [ngStyle]="getInputStyles()"
      matInput
      [placeholder]="placeholderText"
      [formControl]="inputText"
      (keyup)="onKeyUp($event)"
      [maxlength]="characterLimit"
      [required]="isRequired"
    ></textarea>
  </mat-form-field>
</form>
<mat-error
  class="shared-textarea-error"
  id="shared-textarea-error-character-limit-wrapper"
  *ngIf="characterLimit"
>
  <app-text
    id="shared-textarea-error-character-limit-text"
    *ngIf="inputText.value?.length === characterLimit"
    [textStyleType]="'caption'"
    class="red-color"
    >{{ 'shared.components.textarea.characterLimit.errorMsg' | translate }}
    {{ characterLimit }}
  </app-text>
</mat-error>
<mat-error
  class="shared-textarea-error"
  id="shared-textarea-custom-error-wrapper"
  *ngIf="hasCustomError"
>
  <app-text
    [textStyleType]="'body1'"
    class="red-color"
    id="shared-textarea-custom-error-text"
    >{{ customErrorMsg }}</app-text
  >
</mat-error>
<mat-error
  id="shared-textarea-pattern-error-wrapper"
  *ngIf="
    inputText.hasError('pattern') && inputText.dirty && shouldShowInvalidFormatError()
  "
>
  <app-text
    id="shared-textarea-pattern-error-text"
    [textStyleType]="'caption'"
    class="red-color"
    >{{ 'input.invalidFormat' | translate }}</app-text
  >
</mat-error>

<ng-container *ngIf="!commentValidatorConfig?.errConfig?.['required']?.hide">
  <mat-error
    id="shared-textarea-required-error-wrapper"
    *ngIf="
      inputText.hasError('required') &&
      inputText.touched &&
      shouldShowInvalidFormatError()
    "
  >
    <app-text
      id="shared-textarea-required-error-caption"
      class="red-color"
      [textStyleType]="'caption'"
      >{{ requiredErrorMessage | translate }}</app-text
    >
  </mat-error>
</ng-container>

<mat-error
  id="shared-textarea-error-maxlength"
  *ngIf="
    inputText.hasError('maxlength') && inputText.dirty && shouldShowInvalidFormatError()
  "
>
  <app-text
    id="shared-textarea-error-maxlength-text"
    class="red-color"
    [textStyleType]="'caption'"
    >{{ 'input.maxlength' | translate }} {{ softMaxLength }}.</app-text
  >
</mat-error>

<ng-container *ngFor="let key of commentValidatorConfig?.errKey">
  <mat-error
    [ngClass]="customTextAreaClass"
    id="{{ commentValidatorConfig.errConfig[key].id }}-error"
    *ngIf="inputText.hasError(key) && commentValidatorConfig.errConfig[key].hide"
  >
    <app-text
      id="{{ commentValidatorConfig.errConfig[key].id }}-error-caption"
      [textStyleType]="'caption'"
      class="red-color"
    >
      {{ commentValidatorConfig.errConfig[key].msg | translate }}
    </app-text>
  </mat-error>
</ng-container>
